<template>
  <button
    class="flex items-center gap-2 text-xl font-medium text-[var(--brand)] text-nowrap [&_svg]:text-[var(--brand)]"
    @click="handleLogout"
  >
    <svg-icon name="ic-arrow-exit" />
    {{ $t('b2b|profile|logout') }}
  </button>
</template>

<script setup>
import AuthService from '@/packages/auth-service'
import SvgIcon from '@/shared/ui/SvgIcon/SvgIcon.vue'

function handleLogout() {
  AuthService.logout()
}
</script>
